<mat-card class="menupannel">
  <div class="resUser">
    <button mat-flat-button (click)="showMyDrive()">
      Task List <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div>
</mat-card>

<div class="taskcontainer">
  <!-- My Drive -->
  <mat-card class="myDrive" [ngClass]="{ open: showmyDrive }">
    <div class="createdfolder">

      <div class="drive mainLink fixlinks">
        <div class="mWorkspace">
          <h2> My Tasks</h2>
        </div>

        <div class="folderName" [ngClass]="{ 'active': (this.IsAllTask && this.taskListID==0)}">          
          <span class="mfname" (click)="onFilterByMyTask(1,'All Task')"> <mat-icon>home</mat-icon> All Task</span>
        </div>

        <div class="folderName" [ngClass]="{ 'active': (this.IsCreatedByMe && this.taskListID==0)}">          
          <span class="mfname" (click)="onFilterByMyTask(2,'Created by me')"> <mat-icon>edit</mat-icon> Created by me</span>
        </div>

        <div class="folderName" [ngClass]="{ 'active': (this.IsAssignedToMe && this.taskListID==0)}">          
          <span class="mfname" (click)="onFilterByMyTask(3,'Assigned to me')"> <mat-icon>assignment_turned_in</mat-icon> Assigned to me</span>
        </div>

        <div class="folderName" [ngClass]="{ 'active': (this.IsAssignedToMyRole && this.taskListID==0)}">          
          <span class="mfname" (click)="onFilterByMyTask(4,'My Role')"><mat-icon>school</mat-icon> My Role</span>
        </div>
      </div>

      <div class="drive mainLink" style="margin-bottom: 10px;">

        <div class="mWorkspace">
          <h2> Task lists</h2>
          <button mat-icon-button color="primary" (click)="addFolder(addFolderDialog,'folder','')">
            <mat-icon>add</mat-icon>
          </button>
        </div>



        <ng-container *ngFor="let tasklist of taskListFolder; let i = index">
          <div class="folderName" [ngClass]="{ 'active': ((currentTaskList == i) && taskListSelected)}">

            <div class="mfname">

              <div class="nm" (click)="getTaskLists(tasklist,i)">

                <span class="folderIconName">
                  {{tasklist.taskListFolderName}}                   
                </span>
                <span class="taskCount" >{{tasklist.taskListCount}}</span>

                <mat-icon class="arrow_right" aria-hidden="true">

                  <div>
                    <ng-container *ngIf="!((currentTaskList == i) && taskListSelected)">
                      expand_more 
                    </ng-container>
                  </div>

                  <div >
                    <ng-container *ngIf="((currentTaskList == i) && taskListSelected)">
                      chevron_right
                    </ng-container>
                  </div>
                </mat-icon>

                

              </div>


              <div class="opt">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">

                  <button mat-menu-item (click)="ShowTemplateFromFolder(Addtemplate,tasklist.taskListFolderID,false,i)">  
                    <mat-icon>library_add</mat-icon> Add Task List
                  </button>

                  <button mat-menu-item (click)="addRoleTemp(addRole,tasklist,i)">
                    <mat-icon>share</mat-icon> Share
                  </button>
                

                  <button mat-menu-item (click)="updateFolder(updateFolderDialog,'folder',tasklist)">
                    <mat-icon>edit</mat-icon> Rename
                  </button>

                  <button mat-menu-item (click)="deleteTasklistFolder(tasklist)">
                    <mat-icon>delete</mat-icon>
                    Delete
                  </button>

                </mat-menu>
              </div>
            </div>

            <ng-container *ngIf="taskLists.length>0 && i === expandedIndex && taskListSelected">
              <ng-container *ngFor="let list of taskLists">
                
                <div class="subTaskList" style="margin-left:0px;margin-right:0px; "
                  [ngClass]="{ 'active': taskListID === list.taskListID }">
                  
                  <div class="name_email" (click)="OpenTaskList(list)">
                    <p matTooltipClass="tooltip" matTooltip="{{list.taskListName}}">
                      <span (click)="MailToAssignee(list,tasklist,i)" *ngIf="list.isMailSent==false && list.showSendMailMenu==true">Send</span>
                      {{list.taskListName}}
                    </p>
                  </div>

                  <div class="opt">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                     
                      <button mat-menu-item  (click)="openTaskListUrl(list,true)">
                        <mat-icon>link</mat-icon>
                        Open External URL
                      </button>

                      <button mat-menu-item (click)="openTaskListUrl(list)">
                        <mat-icon>content_copy</mat-icon>
                        Copy URL
                      </button>
                      <button mat-menu-item (click)="openTaskListUrlTicket(list)">
                        <mat-icon>content_copy</mat-icon>
                        Copy URL Ticket
                      </button>                     

                      <button *ngIf="list.showSendMailMenu==true" mat-menu-item (click)="MailToAssignee(list,tasklist,i)">
                        <mat-icon>email</mat-icon>
                         <span *ngIf="list.lastSent !== '0001-01-01T00:00:00'">
                          Mail ({{ list.lastSent | date: 'MM/dd/yyyy' }})
                         </span>
                         <span *ngIf="list.lastSent == '0001-01-01T00:00:00'">
                          Mail
                         </span>
                      </button>

                      <button mat-menu-item (click)="updateTaskLists(updateFolderDialog,'task',list,tasklist,i)">
                        <mat-icon>edit</mat-icon>
                        Rename
                      </button>

                      <button mat-menu-item (click)="ShowTemplate(Addtemplate,list)">
                        <mat-icon>library_add</mat-icon>
                        Add Template
                      </button>

                      <button mat-menu-item (click)="SaveAsTemplate(saveAsTemplateDialog,list)">
                        <mat-icon>save</mat-icon>
                        Save as Template
                      </button>

                      <button mat-menu-item (click)="ImportTaskTemplateFromTaskList(importTasktemplate,list)">
                        <mat-icon>swap_horiz</mat-icon>
                        Import Task
                      </button>
                     
                      <button mat-menu-item (click)="deleteTasklist(list,tasklist,i)">
                        <mat-icon>delete</mat-icon>
                        Delete
                      </button>

                      <button mat-menu-item (click)="archivedTaskList(list,tasklist,i)">
                        <mat-icon>archive</mat-icon>
                        Archive
                      </button>

                    </mat-menu>
                  </div>

                </div>


              </ng-container>
            </ng-container>


          </div>

        </ng-container>

      </div>

      <div class="drive mainLink">
        <div class="mWorkspace">
          <h2>Shared with me </h2>
        </div>


        <ng-container *ngFor="let tasklist of taskListFolderSharedWithMe; let i = index">
          <div class="folderName"
            [ngClass]="{ 'active': ((currentTaskListSharedWithMe == i) && taskListSelectedSharedWithMe)}">

            <div class="mfname">

              <div class="nm" (click)="getTaskListsSharedWithMe(tasklist,i)">

                <span class="folderIconName">
                  {{tasklist.name}}
                </span>
                <span class="taskCount" >{{tasklist.taskListCount}}</span>
                
                <mat-icon class="arrow_right" aria-hidden="true">

                  <div>
                    <ng-container *ngIf="!((currentTaskListSharedWithMe == i) && taskListSelectedSharedWithMe)">
                      chevron_right
                    </ng-container>
                  </div>

                  <div (click)="getTaskLists1SharedWithMe(tasklist,i)">
                    <ng-container *ngIf="((currentTaskListSharedWithMe == i) && taskListSelectedSharedWithMe)">
                      expand_more
                    </ng-container>
                  </div>
                </mat-icon>

                

              </div>

              <div class="opt">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">

                  <button mat-menu-item (click)="ShowTemplateFromFolder(Addtemplate,tasklist.id,true,i)">  
                    <mat-icon>library_add</mat-icon> Add Task List
                  </button>                 

                  <button mat-menu-item (click)="addRoleTempSharedWithMe(showRoleSharedWithMe,tasklist,i)">
                    <mat-icon>share</mat-icon> Share
                  </button>

                </mat-menu>
              </div>
            
        </div>

            <ng-container
              *ngIf="taskListsSharedWithMe.length>0 && i === expandedIndexSharedWithMe && taskListSelectedSharedWithMe">
              <ng-container *ngFor="let list of taskListsSharedWithMe">

                <div class="subTaskList" style="margin-left:0px;margin-right:0px;"
                  [ngClass]="{ 'active': taskListIDSharedWithMe === list.taskListID }">

               
                  <div class="name_email" (click)="OpenTaskListSharedWithMe(list)">
                    <p matTooltipClass="tooltip" matTooltip="{{list.taskListName}}">
                      <span (click)="MailToAssignee(list,tasklist,i)" *ngIf="list.isMailSent==false && list.showSendMailMenu==true">Send</span>
                      {{list.taskListName}}
                    </p>
                  </div>

                  <!-- <div class="name_email" (click)="OpenTaskListSharedWithMe(list)">
                    <p matTooltipClass="tooltip" matTooltip="{{list.taskListName}}">
                      {{list.taskListName}}
                    </p>
                  </div> -->
                
                  <div class="opt">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                     
                      <button mat-menu-item  (click)="openTaskListUrl(list,true)">
                        <mat-icon>link</mat-icon>
                        Open External URL
                      </button>
                      
                      <button mat-menu-item (click)="openTaskListUrl(list)">
                        <mat-icon>content_copy</mat-icon>
                        Copy URL
                      </button>

                      <button mat-menu-item (click)="openTaskListUrlTicket(list)">
                        <mat-icon>content_copy</mat-icon>
                        Copy URL Ticket
                      </button>
                     

                      <button *ngIf="list.showSendMailMenu==true" mat-menu-item (click)="MailToAssigneeSharedWithMe(list,tasklist,i)">
                        <mat-icon>email</mat-icon>
                          <span *ngIf="list.lastSent !== '0001-01-01T00:00:00'">
                          Mail ({{ list.lastSent | date: 'MM/dd/yyyy' }})
                         </span>
                         <span *ngIf="list.lastSent == '0001-01-01T00:00:00'">
                          Mail
                         </span>
                      </button>

                      <button mat-menu-item (click)="updateTaskListsSharedWithMe(updateFolderDialog,'task',list,tasklist,i)">
                        <mat-icon>edit</mat-icon>
                        Rename
                      </button>

                      <!-- <button mat-menu-item (click)="ShowTemplate(Addtemplate,list)">
                        <mat-icon>library_add</mat-icon>
                        Add Template
                      </button>

                      <button mat-menu-item (click)="SaveAsTemplate(saveAsTemplateDialog,list)">
                        <mat-icon>save</mat-icon>
                        Save as Template
                      </button>

                      <button mat-menu-item (click)="ImportTaskTemplateFromTaskList(importTasktemplate,list)">
                        <mat-icon>swap_horiz</mat-icon>
                        Import Task
                      </button>
                      -->
                      <button mat-menu-item (click)="deleteTasklistSharedWithMe(list,tasklist,i)">
                        <mat-icon>delete</mat-icon>
                        Delete
                      </button>

                      <button mat-menu-item (click)="archivedTaskListSharedWithMe(list,tasklist,i)">
                        <mat-icon>archive</mat-icon>
                        Archive
                      </button>

                    </mat-menu>
                  </div>

                </div>


              </ng-container>
            </ng-container>


          </div>

        </ng-container>

      </div>

      <div class="drive mainLink">
        <div class="mWorkspace" style="margin-bottom: 10px;">
          <h2>Archived </h2>
        </div>


        <ng-container *ngFor="let tasklist of taskListArchived; let i = index">
          <div class="folderName"
            [ngClass]="{ 'active': ((currentTaskListArchived == i) && taskListSelectedArchived)}">

            <div class="mfname">

              <div class="nm" (click)="getTaskListsArchived(tasklist,i)">


                <span class="folderIconName" >
                  
                  {{tasklist.name}}
                </span>

                <mat-icon *ngIf="tasklist.id==1" class="arrow_right" aria-hidden="true">

                  <div >
                    <ng-container *ngIf="!((currentTaskListArchived == i) && taskListSelectedArchived)">
                      chevron_right
                    </ng-container>
                  </div>

                  <div (click)="getTaskLists1Archived(tasklist,i)">
                    <ng-container *ngIf="((currentTaskListArchived == i) && taskListSelectedArchived)">
                      expand_more
                    </ng-container>
                  </div>
                </mat-icon>

                

              </div>


           </div>

            <ng-container
              *ngIf="taskListsArchived.length>0 && i === expandedIndexArchived && taskListsArchived">
              <ng-container *ngFor="let list of taskListsArchived">

                <div class="subTaskList" style="margin-left:0px;margin-right:0px;"
                  [ngClass]="{ 'active': taskListIDArchived === list.taskListID }">

                 
                  <div class="name_email" (click)="OpenTaskListArchived(list)">

                    <p  matTooltipClass="tooltip" matTooltip="{{list.taskListName}}">
                      {{list.taskListName}}
                    </p>                  

                  </div>

                  <div class="opt">
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                      <mat-icon>more_vertical</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">

                      <button mat-menu-item (click)="UnarchivedTaskList(list,tasklist,i)">
                        <mat-icon>unarchive</mat-icon>
                        Unarchive
                      </button>

                    </mat-menu>
                  </div>

                </div>


              </ng-container>
            </ng-container>


          </div>

        </ng-container>

      </div>

    </div>
  </mat-card>

  <div class="myDriveOverlay" (click)="showMyDrive()" [ngClass]="{ open: showmyDrive }"></div> 

  <div class="right">
    <mat-card class="filter">
      <div class="pageHeading">       

        <button mat-flat-button [matMenuTriggerFor]="notification" class="user-button">
          {{myTaskText}} <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu class="customPanel" #notification="matMenu">
          <mat-card class="filterOptionList">
            <div class="fillist">
              <div class="filterlist">

                <div class="lList">
                  <span class="name" (click)="onFilterByMyTask(1,'All Task')">All Task</span>

                  <button mat-icon-button>
                    <mat-icon class="star">bookmark</mat-icon>
                  </button>

                  <button mat-icon-button class="remove">
                    <mat-icon class="">highlight_off</mat-icon>
                  </button>
                </div>
                <div class="lList">
                  <span class="name" (click)="onFilterByMyTask(2,'Created by me')">Created by me</span>

                  <button mat-icon-button>
                    <mat-icon class="star">bookmark</mat-icon>
                  </button>

                  <button mat-icon-button class="remove">
                    <mat-icon class="">highlight_off</mat-icon>
                  </button>
                </div>
                <div class="lList">
                  <span (click)="onFilterByMyTask(3,'Assigned to me')" class="name">Assigned to me</span>

                  <button mat-icon-button>
                    <mat-icon class="star">bookmark</mat-icon>
                  </button>

                  <button mat-icon-button class="remove">
                    <mat-icon class="">highlight_off</mat-icon>
                  </button>
                </div>
                <div class="lList">
                  <span class="name" (click)="onFilterByMyTask(4,'My Role')">My Role</span>

                  <button mat-icon-button>
                    <mat-icon class="star">bookmark</mat-icon>
                  </button>

                  <button mat-icon-button class="remove">
                    <mat-icon class="">highlight_off</mat-icon>
                  </button>
                </div>

              </div>
            </div>
          </mat-card>
        </mat-menu>

      </div>



      <div class="sort">
        <button mat-icon-button *ngIf="showMoveToOption" (click)="moveTo(MoveTo)">
          <mat-icon>low_priority</mat-icon>
        </button>

        <!-- <button mat-icon-button *ngIf="showMoveToOption" (click)="SaveAsTemplateMultiple(saveAsTemplateDialog)">
          <mat-icon>save</mat-icon>        
        </button> -->

        <button mat-icon-button *ngIf="showMoveToOption" (click)="deleteMultipleTask()">
          <mat-icon>delete</mat-icon>
        </button>

        <div class="add" *ngIf="showMoveToOption">
          <button mat-button color="primary" [matMenuTriggerFor]="menu1">Action</button>
          <mat-menu #menu1="matMenu">
            <button mat-menu-item (click)="multipleMakeTaskRequired()"
              matTooltipClass="tooltip" matTooltip="Required">
              <mat-icon style="color: red;">check</mat-icon>
              Required
            </button>
            
             <button mat-menu-item (click)="multipleMakeTaskUnRequired()"
               matTooltipClass="tooltip" matTooltip="UnRequired">
             <mat-icon>check</mat-icon>
               UnRequired
              </button> 
              <button mat-menu-item 
               matTooltipClass="tooltip" matTooltip="External" (click)="multipleMakeTaskExternalInternal(false)">
               <mat-icon>arrow_outward</mat-icon>
               External
              </button>
              <button mat-menu-item 
               matTooltipClass="tooltip" matTooltip="Internal" (click)="multipleMakeTaskExternalInternal(true)">
               <mat-icon>call_received</mat-icon>
               Internal
              </button>           
          </mat-menu>
        </div>
      

        <button mat-stroked-button  [ngClass]="{'active': preorityArray.length>0}"
          [matMenuTriggerFor]="priority">{{preoritytext}}<mat-icon>arrow_drop_down</mat-icon></button>
        <mat-icon class="cancelFilter" (click)="clearPreoority()" *ngIf="preorityArray.length>0">close</mat-icon>
        <mat-menu #priority="matMenu">
          <button mat-menu-item (click)="onFilterByPreority(1,'Lowest')">Lowest</button>
          <button mat-menu-item (click)="onFilterByPreority(2,'Low')">Low</button>
          <button mat-menu-item (click)="onFilterByPreority(3,'Medium')">Medium</button>
          <button mat-menu-item (click)="onFilterByPreority(4,'High')">High</button>
          <button mat-menu-item (click)="onFilterByPreority(5,'Highest')">Highest</button>
        </mat-menu>



        <button mat-stroked-button color="" [ngClass]="{'active': statustext!=='Status'}"
          [matMenuTriggerFor]="status">{{statustext}}<mat-icon>arrow_drop_down</mat-icon></button>
        <mat-icon class="cancelFilter" *ngIf="statustext!=='Status'" (click)="clearStatus()">close</mat-icon>
        <mat-menu #status="matMenu">
          <button *ngFor="let stat of taskStatusList" mat-menu-item
            (click)="GettaskByFilterStatus(stat.taskStatusID,stat.taskStatusName)">{{stat.taskStatusName}}</button>
        </mat-menu>

        <button mat-stroked-button color="" [ngClass]="{'active': dueDatetext!=='Due Date'}"
        [matMenuTriggerFor]="dueDate">{{dueDatetext}}<mat-icon>arrow_drop_down</mat-icon></button>
      <mat-icon class="cancelFilter" *ngIf="dueDatetext!=='Due Date'" (click)="clearDuedate()">close</mat-icon>
      <mat-menu #dueDate="matMenu">
        <button mat-menu-item (click)="GettaskByFilter('Today')">Today</button>
        <button mat-menu-item (click)="GettaskByFilter('Tomorrow')">Tomorrow</button>
        <button mat-menu-item (click)="GettaskByFilter('This Week')">This Week</button>
        <button mat-menu-item (click)="GettaskByFilter('Next Week')">Next Week</button>
        <button mat-menu-item (click)="GettaskByFilter('Overdue')">Overdue</button>
      </mat-menu>

      </div>

      <div class="search">

        <mat-form-field appearance="fill" class="searchField">
          <mat-label>Search task</mat-label>
          <input matInput type="text" (input)="getSearchResults()" [(ngModel)]="value" />
          <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearSerachText()">
            <mat-icon>close</mat-icon>
          </button>
          <button *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="value = ''">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <button *ngIf="ShowCustomColumn==true" class="viewBtn" mat-icon-button (click)="customizeColumn(customize)"
        matTooltipClass="tooltip" matTooltip="Customize Coloumn">
        <mat-icon>view_column</mat-icon>
      </button>
     

      <div class="add">
        <button mat-button color="primary" [matMenuTriggerFor]="menu"><mat-icon>add</mat-icon> Task</button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="createNewTask()">
            <mat-icon>create</mat-icon>
            Create Task
          </button>          
          <button mat-menu-item (click)="ImportTaskTemplate(importTasktemplate)">
            <mat-icon>import_export</mat-icon>
            Import Task
          </button>
          <button *ngIf="showAddGroupButton==true" mat-menu-item  (click)="createGroup()">
            <mat-icon>group_add</mat-icon>
            New Group
          </button>
        </mat-menu>
      </div>

      
    </mat-card>
    <!-- Filter -->

    <div class="tableHolder">
      <mat-card class="task_holder--group--items--row cellHeader">

        <div class="task_header_holder">
          <ng-container>
            <div class="task-cell cellName">
              <div class="Headeroutside">
                <mat-checkbox class="taskcheck" color="primary" [disabled]="ShowNoRecordFound"
                  (change)="$event ? masterToggleNew() : null" [checked]="selection.hasValue() && isAllSelectedNew()">
                </mat-checkbox>
              </div>
              Title
            </div>
            <div class="task-cell cellDueDate">Required</div>
            <div class="task-cell cellDueDate">Assign</div>
            <div class="task-cell cellDueDate">Attach</div>
            <div class="task-cell cellDueDate">Created</div>
            <div class="task-cell cellDueDate">Due</div>
            <div class="task-cell cellStatus">Status</div>
            <div class="task-cell cellPriority">Priority</div>
            <div class="task-cell cellAction">Action</div>
          </ng-container>

          <ng-container *ngIf="ShowCustomColumn==true && FieldColumn.length>0">           
            <div class="task-cell cellPriority" *ngFor="let clm of FieldColumn">
              <span>{{clm.fieldName}}</span>
            </div>           
          </ng-container>
        </div>

      </mat-card>
      <div class="task_holder" *ngFor="let column of columns" style="width:100%">
        <div class="task_holder--group" cdkDropList [cdkDropListData]="column.groups"
          (cdkDropListDropped)="dropGroup($event)">
          <mat-card class="task_holder--group--items" *ngFor="let group of column.groups" cdkDropListGroup cdkDrag
            [cdkDragDisabled]="group.dragDisabled" [cdkDragData]="group">
            <h2 *ngIf="(taskListID>0 || taskListIDSharedWithMe>0) && group.id!=0">

              <ng-container *ngIf="group.id==0">
                {{group.title}}
              </ng-container>

              <input *ngIf="group.id>0" type="text" maxlength="50" (change)="onChangeGroupName($event,group)"
                value="{{group.title}}">    

              <span class="delete">
               <span style="display: flex;" *ngIf="group.id>0 && group.processStageID>0"> {{group.processStageName}}
                 <button *ngIf="group.processStageName" matTooltip="Remove" mat-icon-button (click)="deleteprocessStage(group)">
                   <mat-icon>close</mat-icon>
                  </button>
               </span>
                <span *ngIf="group.id>0 && group.groupType==1 && group.isTriggered==false" 
                  (click)="TriggerTaskGroup(group)">
                  <button mat-icon-button 
                     matTooltipClass="tooltip" matTooltip="Trigger Task Group">
                    <mat-icon>alarm_add</mat-icon>
                  </button>
                </span>


                <span *ngIf="group.id>0 && group.isTriggered==true" mat-icon-button matTooltipClass="tooltip" matTooltip="Triggered">
                  Triggered
                </span>
                
                <ng-container *ngIf="group.id>0">
                  <button mat-icon-button matTooltipClass="tooltip" matTooltip="Add Process Stage" (click)="selectStagePopUp(group)">
                    <mat-icon>note_add</mat-icon>
                  </button>
                </ng-container>

                <div class="add" *ngIf="group.id>0 && group.isTriggered==false">
                  <button mat-icon-button  [matMenuTriggerFor]="menu">
                  <mat-icon>settings</mat-icon></button>
                  <mat-menu #menu="matMenu">
                    <mat-radio-group >
                      <mat-radio-button class="radOpt" value="Normal" [checked]="group.groupType==0" (change)="ChangeGroupType($event,group,0)">Normal</mat-radio-button>
                      <br>
                      <mat-radio-button class="radOpt" value="Trigger" [checked]="group.groupType==1" (change)="ChangeGroupType($event,group,1)">Trigger</mat-radio-button>                        
                    </mat-radio-group>
                                 
                  </mat-menu>
                </div>

                <ng-container *ngIf="group.id>0">
                  <button mat-icon-button class="trash" (click)="removeGroup(group)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </ng-container>
              

              </span>

            </h2>

            <form [formGroup]="statusGroup">
              <mat-card style="width:100%" class="" cdkDropList id="{{group.id}}"
                [cdkDropListData]="group.items" (cdkDropListDropped)="dropItem($event)"
                [cdkDropListConnectedTo]="getConnectedList()">

                <div class="task_holder--group--items--row" *ngFor="let item of group.items; let i = index" cdkDrag
                  [cdkDragData]="item" [cdkDragDisabled]="taskListID==0 && taskListIDSharedWithMe==0">
                  <!-- [cdkDragDisabled]="taskListID==0 && taskListIDSharedWithMe==0" -->
                  <div class="task-cell cellName">
                    <div class="outside">                    
                      <mat-checkbox class="taskcheck" color="primary" (change)="isAllSelectedRow($event,item)"
                        (change)="$event ? selection.toggle(item) : null" [checked]="selection.isSelected(item)">
                      </mat-checkbox>
                    </div>

                    <button mat-icon-button (click)="markComplete(item)"
                      [ngClass]="{ markComplete: item.status==completedTaskStatusID }">
                      <mat-icon>check_circle_outline</mat-icon>
                    </button>

                    <div class="tname" (click)="getTaskDetail(item)">
                      <span *ngIf="taskListID==0 && taskListIDSharedWithMe==0" (click)="getTaskDetail(item)"
                        class="taskColor" [ngStyle]="{'background-color': item.color}"></span>
                      <span *ngIf="taskListID>0 || taskListIDSharedWithMe>0" (click)="getTaskDetail(item)"
                        class="taskColor" [ngStyle]="{'background-color': item.colourCode}"></span>

                      <span *ngIf="taskListID==0 && taskListIDSharedWithMe==0" (click)="getTaskDetail(item)"
                        class="taskTitle">{{ item.taskTitle }}</span>
                      <span *ngIf="taskListID>0 || taskListIDSharedWithMe>0" (click)="getTaskDetail(item)"
                        class="taskTitle">{{ item.taskTitle }}</span>

                      <div class="forHover  taskLocation">                       
                      </div>


                      <div class="taskstatusCount">
                        <span class="complete"
                          *ngIf="item.completedSubTaskCount > 0">{{item.completedSubTaskCount}}</span>
                        <span class="working" *ngIf="item.inprogressTaskCount > 0">{{item.inprogressTaskCount}}</span>
                      </div>

                    </div>

                    <span *ngIf="!item.isInternal" class="externalTask" matTooltipClass="tooltip"
                      matTooltip="External task">
                      <mat-icon>arrow_outward</mat-icon>
                    </span>



                  </div>

                  <div class="task-cell cellDueDate">
                    <span *ngIf="item.isRequired==true" class="externalTask" matTooltipClass="tooltip" (click)="MakeTaskRequired(item,false)"
                      matTooltip="Required">
                      <mat-icon style="color: red;">check</mat-icon>
                    </span>

                    <span *ngIf="item.isRequired==false" class="externalTask" matTooltipClass="tooltip" (click)="MakeTaskRequired(item,true)"
                      >
                    <mat-icon>check</mat-icon>
                    </span>
                  </div>

                  <div class="task-cell cellAssigne" (click)="getTaskDetail(item)">
                    <span> 

                      <div class="userpicinfo">                       
                     
                          <ul class="assignList">

                            <ng-container *ngFor="let item of getAssigne(item.taskAssignedEntity); let i = index; trackBy: trackByFn; " >
                               <li *ngIf="i <= 3">
                                <ng-container *ngIf="item.image; else showName">
                                  <div class="userImage" matTooltipClass="tooltip"   matTooltip="{{item.name}}">
                                    <img src="{{item.image}}" alt="{{item.name}}">
                                  </div>
                                </ng-container>
  
                                <ng-template #showName>
                                    <span class="shortName" matTooltipClass="tooltip" matTooltip="{{item.name}}">
                                      {{ getShortName(item.name) }}
                                    </span> 
                                </ng-template>
                              </li>
                              <li *ngIf="i > 3 && i == 4">
                                <span class="shortName">
                                  +{{4}}
                                </span> 
                              </li>
                            </ng-container>

                            <ng-container *ngIf="getAssigne(item.taskAssignedEntity).length == 0;">
                             <li> -  </li>
                           </ng-container>

                          </ul>

                       
                      </div>
                     

                    </span>
                  </div>

                  <div class="task-cell cellAttach"  (click)="getTaskDetail(item)">
                    <span *ngIf="item.entityTypeAttached==1" matTooltipClass="tooltip" matTooltip="Task location: {{CoreShowName}}">
                      <mat-icon>app_registration</mat-icon>
                    </span>
                    <span *ngIf="item.entityTypeAttached==2" matTooltipClass="tooltip" matTooltip="Task location: {{ContactShowName}}">
                      <mat-icon>contact_mail</mat-icon>
                    </span>
                    <span *ngIf="item.entityTypeAttached==3" matTooltipClass="tooltip" matTooltip="Task location: {{CompanyShowName}}">
                      <mat-icon>business</mat-icon>
                    </span>                   
                    {{getAttach(item.taskAttachedEntity)}}
                  </div>
                  
                  <div class="task-cell cellDueDate" >
                    <p *ngIf="item.createDate == null">
                     -
                    </p>

                    <p *ngIf="item.createDate != null">
                      {{ item.createDate| date: "MM/dd/yyyy" }}
                    </p>
                  </div>


                  <div class="task-cell cellDueDate" (click)="getTaskDetail(item)">
                    <p *ngIf="item.dueDate == null">
                      <mat-icon class="greyIcon">
                        event
                      </mat-icon>
                    </p>

                    <p *ngIf="item.dueDate != null">
                      {{ item.dueDate| date: "MM/dd/yyyy" }}
                    </p>
                  </div>

                  <div class="task-cell cellStatus">


                    <ng-select [readonly]="SingleTaskArchived==true" formControlName="status{{item.taskId}}" [searchable]="false" [clearAllText]="false"
                      (change)="onTaskListStatusChange($event,item)" class="status_dropdown">

                      <ng-option *ngFor="let stat of taskStatusList" [value]="stat.taskStatusID">
                        <span class="statusOptions" [style.background]="getBackground(stat.taskStatusID)">{{
                          stat.taskStatusName }}</span>
                      </ng-option>

                    </ng-select>

                  </div>


                  <div class="task-cell cellPriority">

                    <ng-select [readonly]="SingleTaskArchived==true" class="priority_dropdown" formControlName="priority{{item.taskId}}" [searchable]="false"
                      [clearAllText]="false" (change)="onTaskListPriorityChange($event,item)">

                      <ng-option *ngFor="let priority of taskPriorityNameColorCode" [value]="priority.val">
                        <span class="statusOptions"
                          [ngStyle]="{'color': priority.color}"><mat-icon>{{priority.icon}}</mat-icon>{{ priority.name
                          }}</span>
                      </ng-option>

                    </ng-select>


                  </div>

                  <div *ngIf="SingleTaskArchived==false"   class="task-cell cellAction">

                    <span mat-icon-button [matMenuTriggerFor]="taskSubActions"><mat-icon>more_vert</mat-icon>
                    </span>
                    <mat-menu class="taskMatMenu" #taskSubActions="matMenu" xPosition="before">                     
                      <button mat-menu-item (click)="openTaskUrl(item)">
                        <mat-icon>content_copy</mat-icon>Copy URL
                      </button>
                      <button mat-menu-item (click)="SaveAsTemplateForSingleTask(saveAsTemplateTaskDialog,item)">                      
                        <mat-icon>save</mat-icon>
                        Save as Template
                      </button>
                      <button mat-menu-item (click)="sendManualTaskReminder(sendReminder,item)">
                        <mat-icon> email</mat-icon>
                        Send Email Notification</button>
                      <button mat-menu-item (click)="ArchiveTask(item)">
                        <mat-icon>archive</mat-icon>
                        Archive
                      </button>
                      <button mat-menu-item (click)="deleteTask(item)">
                        <mat-icon>delete</mat-icon>
                        Delete
                      </button>
                    </mat-menu>
                  </div>

                  <div *ngIf="SingleTaskArchived==true"  class="task-cell cellAction">

                    <span mat-icon-button [matMenuTriggerFor]="taskSubActions1"><mat-icon>more_vert</mat-icon>
                    </span>
                    <mat-menu class="taskMatMenu" #taskSubActions1="matMenu" xPosition="before">                    
                      <button mat-menu-item (click)="UnArchiveTask(item)">UnArchive</button>                     
                    </mat-menu>
                  </div>


                  <ng-container *ngIf="ShowCustomColumn && FieldColumn.length > 0"  >
                    <div  *ngFor="let rowdata of FieldColumn"  
                    [ngClass]="{'task-cell': true, 'cellPriority': true,'email': getFieldType(rowdata, item)}" >

                    <ng-container *ngIf="getFieldType(rowdata, item); else defaultView">
                      <span
                        matTooltipClass="tooltip"
                        matTooltip="{{ getFieldColumnValues(rowdata, item) }}"
                      >
                        {{ getFieldColumnValues(rowdata, item) }}
                      </span>
                    </ng-container>
                
                    <ng-template #defaultView>
                      {{ getFieldColumnValues(rowdata, item) }}
                    </ng-template>
                    </div>
                  </ng-container>
                  
                  
              
                </div>
              </mat-card>
            </form>
           
          </mat-card>
          
          
        </div>
        
      </div>
    </div>

<div class="loading_more" *ngIf="showLoadingData==true" >Loading data please wait..</div>


    <ng-container *ngIf="showAssignedTask">
      <div class="createTask" cdkDrag cdkDragBoundary=".right">
        <app-task-assign [taskId]="taskId" [fromList]="true" (closeAssignedTask)="closeTask($event)">
        </app-task-assign>
      </div>
    </ng-container>

    <ng-container *ngIf="showReminderTask">
      <div class="createTask" cdkDrag cdkDragBoundary=".right">
        <app-task-reminder (closeAssignedTask)="closeReminder($event)">
        </app-task-reminder>
      </div>
    </ng-container>

    <ng-container *ngIf="showScheduleTask">
      <div class="createTask" cdkDrag cdkDragBoundary=".right">
        <app-task-schedule-by (closeAssignedTask)="closeSchedule($event)">
        </app-task-schedule-by>
      </div>
    </ng-container>

    <ng-container *ngIf="showAttachTask">
      <div class="createTask" cdkDrag cdkDragBoundary=".right">
        <app-task-attach-ccc [taskId]="taskId" [fromList]="true" (closeAssignedTask)="closeAttach($event)">
        </app-task-attach-ccc>
      </div>
    </ng-container>

    <ng-container *ngIf="showCreateTask">
      <mat-card class="createTask setMaxH" cdkDrag cdkDragBoundary=".right">
        <app-addtask (getCloseCreateTask)="getCloseCreateTask()" (getSaveTask)="getSaveTask()"
          (taskListTaskSaved)="dropTable()" [taskId]="taskId" [moduleName]="moduleNames" [taskListID]="taskListIdForAdd">
        </app-addtask>
      </mat-card>
    </ng-container>
  </div>
</div>


<app-task-details *ngIf="showTaskDetail" [ngClass]="{ open: showTaskDetail }"
  (closeTaskDetail)="closeTaskDetail($event)" (closeSaveTaskDetail)="closeSaveTaskDetail($event)"
  (showPI)="showPIntelligence($event)" [taskId]="taskId" [showAddGroupButton]="showAddGroupButton"
  [taskListID]="taskListID"
  [mainModulename]="mainModuleName" [SingleTaskArchived]="SingleTaskArchived">
</app-task-details>


<app-add-pi [ngClass]="{ open: showProcess }" (closeLinkPI)="closePIntelligence($event)">
</app-add-pi>

<ng-template #addFolderDialog>
  <form [formGroup]="myfolderForm">
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
      Add {{folderTaskName}}
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <mat-form-field class="">
        <mat-label>{{folderTaskName}} Name</mat-label>
        <input matInput formControlName="folderName" maxlength="100" placeholder="add name" />
      </mat-form-field>
      <mat-form-field *ngIf="folderortask=='task'">
        <mat-label>Select Template</mat-label>
        <mat-select (selectionChange)="OnSelectTempChange($event)">
          <mat-option *ngFor="let template of TaskTemplatesList" [value]="template.taskTemplateID">
            {{ template.taskTemplateName }}
          </mat-option>
        </mat-select>      
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="close()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="myfolderForm.invalid || !myfolderForm.dirty" (click)="addTaskListFolder(myfolderForm.value)">
        Add
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>

<ng-template #updateFolderDialog>
  <form [formGroup]="myfolderForm">
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
      Update {{folderTaskName}}
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <mat-form-field class="">
        <mat-label>{{folderTaskName}} Name</mat-label>
        <input matInput formControlName="folderName" maxlength="100" placeholder="update {{folderTaskName}} Name" />
      </mat-form-field>
      
    </mat-dialog-content>
    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="close()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="myfolderForm.invalid || !myfolderForm.dirty" (click)="UpdateTaskListFolder(myfolderForm.value)">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>

<ng-template #rename>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
    Rename Folder
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <mat-form-field class="example-full-width">
      <mat-label>Rename</mat-label>
      <input matInput placeholder="Rename" value="Heart Surgery" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="">Close</button>
    <button mat-button color="primary">Save</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #addAssigne>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>person_add</mat-icon></span>
    Share With Contact Or Role
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <form class="assign">
      <mat-form-field appearence="fill">
        <mat-label>Select Contact or Role</mat-label>
        <input matInput placeholder="Select Contact or Role" />
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <button mat-button color="primary">Assign</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #template>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Create Tasklist 
    <button mat-icon-button (click)="closeTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <div class="searchSelectCat">
      <div class="selectCat">
        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select (selectionChange)="getSelectTaskCategory($event)">
            <mat-option *ngFor="let stat of taskCategoryList" [value]="stat.taskTemplateCategoryID">
              {{ stat.taskTemplateCategoryName }}
            </mat-option>
          </mat-select>
         
        </mat-form-field>
      </div>


      <div class="search">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input matInput maxlength="20" placeholder="search template" (input)="searchTemplate($event.target.value)">
        </mat-form-field>
      </div>
    </div>

    <div class="tempalteList">
      <table cellspacing="0" cellspadding="0">
        <tr>
          <th>Template Name</th>
          <th>Category Name</th>
          <th class="actBtn">Action</th>
        </tr>
        <tr>

          <td class="formName">
            Template 1
          </td>
          <td>Category 1</td>
          <td>

            <button mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip"
              matTooltip="Create Project"><mat-icon>post_add</mat-icon>
            </button>

          </td>
        </tr>
      </table>

    </div>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="" (click)="closeTemplate()">Close</button>
  </mat-dialog-actions>
</ng-template>



<ng-template #taskList>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>note_add</mat-icon></span>
    <span>
      Enter Tasklist Assignee Details.
    </span>   
  </h2>


  <mat-dialog-content>

   
    <mat-form-field class="example-full-width">
      <mat-label>Name <span style="color:red"></span></mat-label>
      <input matInput required placeholder="Enter Assigned Person's Name" [(ngModel)]="userFullName" />
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <mat-label>Email <span style="color:red"></span></mat-label>
      <input matInput placeholder="Enter Assigned Person's email" required type="email" (input)="getEmailVerified()"
        [(ngModel)]="userEmailForCode" />
    </mat-form-field>

    <p class="spNote" >This popup appears because the tasklist assignee hasn't provided their information.</p>

   
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeEmailPopup()">Cancel</button>
   
    <button mat-flat-button class="calltoaction" [disabled]="!isEmailVerified || userFullName.trim()==''" type="submit"
      color="primary" (click)="getConcernedConfirmation()">Save</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #MoveTo>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>note_add</mat-icon></span>
    Move To
    <button mat-icon-button (click)="closeMoveto()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>

    <div class="drive mainLink">
      <ng-container *ngFor="let tasklist of taskListFolderForMoveTo; let i = index">
        <div class="folderName" [ngClass]="{ 'active': ((currentTaskListMoveTo == i) && taskListSelectedMoveTo)}">

          <div class="mfname">

            <div class="nm" (click)="getTaskListsForMoveTo(tasklist,i)">

              <span class="folderIconName">
                {{tasklist.taskListFolderName}}                   
              </span>
              <span class="taskCount" >{{tasklist.taskListCount}}</span>

              <mat-icon class="arrow_right" aria-hidden="true">

                <div>
                  <ng-container *ngIf="!((currentTaskListMoveTo == i) && taskListSelectedMoveTo)">
                    expand_more 
                  </ng-container>
                </div>

                <div>
                  <ng-container *ngIf="((currentTaskListMoveTo == i) && taskListSelectedMoveTo)">
                    chevron_right
                  </ng-container>
                </div>
              </mat-icon>              

            </div>          
          </div>

          <ng-container *ngIf="taskListsForMoveTo.length>0 && i === expandedIndexmoveTo && taskListSelectedMoveTo">
            <ng-container *ngFor="let list of taskListsForMoveTo">
            
              <div class="subTaskList" style="margin-left:0px;margin-right:0px;" (click)="SelectTaskList(list)"
                [ngClass]="{ 'active': taskListIDMoveTo === list.taskListID }">
                
                <div class="name_email">
                  <p matTooltipClass="tooltip" matTooltip="{{list.taskListName}}">
                    {{list.taskListName}}
                  </p>
                </div>             
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
        <!-- <div class="folderName" *ngFor="let tasklist of taskListFolderForMoveTo; let i = index">
          <div class="nm" (click)="getTaskLists(tasklist,i)">

            <span class="folderIconName">
              {{tasklist.taskListFolderName}}                   
            </span>
            <span class="taskCount" >{{tasklist.taskListCount}}</span>

            <mat-icon class="arrow_right" aria-hidden="true">

              <div>
                <ng-container *ngIf="!((currentTaskList == i) && taskListSelected)">
                  expand_more 
                </ng-container>
              </div>

              <div >
                <ng-container *ngIf="((currentTaskList == i) && taskListSelected)">
                  chevron_right
                </ng-container>
              </div>
            </mat-icon>
            

          </div>
        
        <ng-container *ngIf="taskListsForMoveTo.length>0 && i === expandedIndexmoveTo">
          <ng-container *ngFor="let list of taskListsForMoveTo">

            <div class="subTaskList" style="margin-left:0px;margin-right:0px;" (click)="SelectTaskList(list)">

              <p [ngClass]="{ 'active': taskListIDMoveTo === list.taskListID }">
                {{list.taskListName}}
              </p>

            </div>

          </ng-container>
        </ng-container>

      </div> -->
           
    </div>


  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeMoveto()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" [disabled]="!ButtonForMoveTo"
      (click)="MoveToTaskList()">
      MoveTo
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>

</ng-template>


<ng-template #saveAsTemplateDialog>
  <form [formGroup]="addTemplateForm">
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
      Save/Update Template
      <button mat-icon-button (click)="closeSaveAsTemplate()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <mat-radio-group color="primary" aria-label="Select an option">
        <mat-radio-button value="0" (change)="OnCategoryChange(0)" [checked]="categoryType==0"
          style="margin-right: 15px;">My Templates</mat-radio-button>
        <mat-radio-button value="2" *ngIf="isOrganizationAdmin" (change)="OnCategoryChange(2)" [checked]="categoryType==2"
          style="margin-right: 15px;">Save as Organization
          Template</mat-radio-button>
        <mat-radio-button value="1" *ngIf="isSuperAdmin" (change)="OnCategoryChange(1)" [checked]="categoryType==1">Save
          Global Template Only</mat-radio-button>
      </mat-radio-group>

      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="getTabDetails($event)">
        <mat-tab label="New">

          <div class="tabContainer">
            <div class="d-flex">

              <mat-form-field appearance="fill">
                <mat-label>Select Category</mat-label>
                <mat-select formControlName="folderID">
                  <mat-option *ngFor="let stat of filteredTaskCategoryList" [value]="stat.taskTemplateCategoryID">
                    {{ stat.taskTemplateCategoryName }}
                  </mat-option>
                </mat-select>

              </mat-form-field>

              <button class="addBtn" mat-icon-button color="primary" (click)="openDialogAddWithRef()">
                <mat-icon>add</mat-icon> </button>


            </div>
            <mat-form-field class="">
              <mat-label>Template Name</mat-label>
              <input matInput formControlName="taskTemplateName" maxlength="100" placeholder="add template name" />
            </mat-form-field>
          </div>
        </mat-tab>

        <mat-tab label="Update Existing">
          <div class="tabContainer">

            <div class="searchSelectCat">
              <div class="selectCat">
                <mat-form-field appearance="fill">
                  <mat-label>Select Category</mat-label>
                  <mat-select (selectionChange)="getSelectTaskCategory($event)">
                    <mat-option value="0">All</mat-option>
                    <mat-option *ngFor="let stat of filteredTaskCategoryList" [value]="stat.taskTemplateCategoryID">
                      {{ stat.taskTemplateCategoryName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>


              <div class="search">
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>Search</mat-label>
                  <input matInput maxlength="20" placeholder="search template"
                    (input)="searchTemplate($event.target.value)">
                </mat-form-field>
              </div>
            </div>


            <div class="tempalteList">
              <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
                <tr>
                  <th>Template Name</th>
                  <th>Category Name</th>
                  <th class="actBtn">Action</th>
                </tr>
                <tr *ngFor="let template of TaskTemplatesList"
                  [ngClass]="{ 'active': template.taskTemplateID === taslTemplateID}">

                  <td class="formName">
                    {{template.taskTemplateName}}
                  </td>

                  <td *ngIf="template.folderName==null">-</td>
                  <td *ngIf="template.folderName!=null">{{template.folderName}}</td>

                  <td>
                    <button mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip"
                      matTooltip="Select" (click)="SelectTemplateForAddTaskList(template)"><mat-icon>post_add</mat-icon>
                    </button>
                  </td>
                </tr>
              </table>
              <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Records Found</div>
            </div>
          </div>

        </mat-tab>
      </mat-tab-group>

    </mat-dialog-content>

    <mat-dialog-actions *ngIf="showNew" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSaveAsTemplate()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="addTemplateForm.invalid || !addTemplateForm.dirty" (click)="AddTaskTemplate(addTemplateForm.value)">
        Add
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

    <mat-dialog-actions *ngIf="showExisting" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSaveAsTemplate()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="!updateTaskTemplateTasksButton" (click)="updateTaskTemplateTasks(addTemplateForm.value)">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

  </form>
</ng-template>


<ng-template #Addtemplate>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Create Tasklist    
    <button mat-icon-button (click)="closeTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-form-field class="w150" appearance="fill">
    <mat-label>Tasklist Name</mat-label>
    <input matInput [(ngModel)]="addtaskTemplateName"  maxlength="100" placeholder="Add Tasklist Name" />
  </mat-form-field>

  <h3 class="tempGallery">Template Gallery</h3>

    <div class="template-holder">
      <div class="left">

        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select (selectionChange)="onTaskListTabChange($event)" value="My Template" >
            <mat-option value="My Template">My Template</mat-option>
            <mat-option value="Organization">Organization</mat-option>
            <mat-option value="Global">Global</mat-option>
          </mat-select>
        </mat-form-field>

        

        <div class="list" #categoryList>
          <ul>
            <li (click)="getTaskListThroughCategory(0, 0)" [ngClass]="{'active': currentIndex == 0 }" >All</li>
            <ng-container  *ngFor="let stat of filteredTaskCategoryList; let i = index">
              <li (click)="getTaskListThroughCategory(stat.taskTemplateCategoryID, i+1)" [ngClass]="{'active': currentIndex == i+1 }"  > {{ stat.taskTemplateCategoryName }}</li>
            </ng-container>           
          </ul>
        
        </div>

      </div>
     <div class="right"> 
       
       <div class="searrch">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input matInput maxlength="20" placeholder="search template"
            (input)="searchTemplate($event.target.value)">
        </mat-form-field>

        <mat-form-field class="" appearance="fill">
          <mat-select placeholder="Select Type" (selectionChange)="getDrpFields($event)">
            <mat-option *ngFor="let stat of taskSubFolderList" [value]="stat.subFolderID">
              {{ stat.folderName }}
          </mat-option>
          </mat-select>
        </mat-form-field>

       
       </div>


  
       <div class="list">

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
            <tr>
              <th>Template Name</th>             
              <th class="actBtn">Action</th>
            </tr>
            <tr *ngFor="let template of FilteredTaskTemplatesList"
              [ngClass]="{ 'active': template.taskTemplateID === taslTemplateID}">

              <td class="formName">
                {{template.taskTemplateName}}
              </td>            

              <td>
                <span class="import" (click)="templateSelected(template)" >Select</span>
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
        </div>

       </div>
          
     </div>
  </div>  

  <!-- <section class="importTo" >
    <p>Would you like to import data for the newly created task-list? If so, please select the appropriate options below. If not, simply uncheck any boxes you do not wish to pull data from.</p>
    <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach</mat-checkbox> &nbsp;
    <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assignee</mat-checkbox>&nbsp;
    
  </section> -->




  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">


    <section class="wouldLike" >
      <div class="info">
        <p>Select or deselect the options below </p>
      </div>
      <div class="checkBoxes">
        <!-- <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach the same {{CoreShowName}} as template</mat-checkbox> &nbsp; -->
        <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assign the same Users as template</mat-checkbox>&nbsp;
      </div>
      <!-- <mat-checkbox color="primary" [(ngModel)]="NotifyChecked" (change)="showOptions($event,'Notify')">Notify</mat-checkbox> -->
    </section>

    
    
    <button mat-button color="basic" (click)="closeTemplate()">Cancel</button>



    <button  mat-flat-button class="calltoaction" type="submit" color="primary"
      (click)="SelectTemplate()">
      Add
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>

</ng-template>


<ng-template #AddTaskListTemplate>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Add Task List
    <button mat-icon-button (click)="closeTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>

    <div class="search">
      <mat-form-field class="example-full-width" appearance="fill">
        <mat-label>Task List Name</mat-label>
        <input matInput maxlength="100" placeholder="Add name" (input)="onTaskListNameChange($event.target.value)" />
      </mat-form-field>
    </div>

    <div class="searchSelectCat">
      <div class="selectCat">
        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select (selectionChange)="getSelectTaskCategory($event)">
            <mat-option value="0">All</mat-option>
            <mat-option *ngFor="let stat of taskCategoryList" [value]="stat.taskTemplateCategoryID">
              {{ stat.taskTemplateCategoryName }}
            </mat-option>
          </mat-select>
          
        </mat-form-field>
      </div>


      <div class="search">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input matInput maxlength="20" placeholder="search template" (input)="searchTemplate($event.target.value)">
        </mat-form-field>
      </div>
    </div>


    <div class="tempalteList">
      <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
        <tr>
          <th>Template Name</th>
          <th>Category Name</th>
          <th class="actBtn">Action</th>
        </tr>
        <tr *ngFor="let template of TaskTemplatesList"
          [ngClass]="{ 'active': template.taskTemplateID === taslTemplateID}">

          <td class="formName">
            {{template.taskTemplateName}}
          </td>

          <td *ngIf="template.folderName==null">-</td>
          <td *ngIf="template.folderName!=null">{{template.folderName}}</td>

          <td>
            <button mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip" matTooltip="Select"
              (click)="SelectTemplateForAddTaskList(template)"><mat-icon>post_add</mat-icon>
            </button>
          </td>
        </tr>
      </table>
      <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
    </div>
  </mat-dialog-content>


  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeTemplate()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" [disabled]="!addTaskListButton"
      (click)="addTaskLists()">
      Add
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>

</ng-template>



<ng-template #addRole>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Add Role
    <button mat-icon-button (click)="closeRole()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <app-contactlist [objectList]="sharedAccessRoleList" [isSharedAccessRolePopup]="true" [isRolePopup]="isRolePopup"
      (NotifyItemSelected)="RoleSelectedForSharedAccess($event)" (NotifyListfetch)="getSharedAccessRoles($event)"
      (click)="onclickRole($event)">
    </app-contactlist>

    <ul class="selectedlist">
      <li *ngFor="let role of selectedsharedAccessRole">
        <div class="userndetail">
          <div class="detail">
            <h4>{{role.name}}</h4>
          </div>
        </div>
        <div class="option">

          <ng-container *ngFor="let action of getActionType(role.actionType)">          

            <button mat-flat-button *ngIf="role.actionType==1" [matMenuTriggerFor]="menu" aria-label="Permission">
              <mat-icon>text_fields</mat-icon> {{action}}
            </button>
          </ng-container>

          <mat-menu #menu="matMenu" xPosition="before">
          
            <button (click)="actionRoleSelected('Editor',1,role.shareToID)" mat-menu-item>
              <mat-icon>text_fields</mat-icon>
              <span>Editor</span>
            </button>
            <button (click)="removeRoles(role,true)" mat-menu-item>
              <mat-icon>delete</mat-icon>
              <span>Remove</span>
            </button>
          </mat-menu>
        </div>
      </li>
    </ul>


  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeRole()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="AddRoleForSeletedFolder()">
      Done
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>
  <br>
  <br>

  <ul class="selectedlist" *ngIf="GetTasklistFolderSharedRolesList.length>0">
     
    <li *ngFor="let user of GetTasklistFolderSharedRolesList">
      <div class="userndetail">
        <div class="pic">
          <img *ngIf="user.imageUrl!='' " src="{{user.imageUrl}}" alt="">
            <span *ngIf="user.imageUrl=='' " class="username">
                {{user.shortName}}
              </span>
        </div>
        <div class="detail">
            <h4>{{user.roleName}}</h4>          
        </div>
    </div>
   
    </li>
  </ul>

  <div *ngIf="showSharedWithFolder==true" class="noRecordFound">Folder Not Shared Yet.</div>
</ng-template>


<ng-template #showRoleSharedWithMe>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>folder_shared</mat-icon>
    </span>
      Shared with
    <button mat-icon-button (click)="closeRole()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

  <ul class="selectedlist" *ngIf="GetTasklistFolderSharedRolesList.length>0">
     
    <li *ngFor="let user of GetTasklistFolderSharedRolesList">
      <div class="userndetail">
        <div class="pic">
          <img *ngIf="user.imageUrl!='' " src="{{user.imageUrl}}" alt="">
            <span *ngIf="user.imageUrl=='' " class="username">
                {{user.shortName}}
              </span>
        </div>
        <div class="detail">
            <h4>{{user.roleName}}</h4>          
        </div>
    </div>
   
    </li>
  </ul>  
   <div *ngIf="showSharedWithFolder==true" class="noRecordFound">Folder Not Shared Yet.</div>
  </mat-dialog-content>

</ng-template>


<ng-template #customize>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Select the columns you want to display in this list
    <button mat-icon-button (click)="closeCustomeColumn()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <mat-dialog-content class="mat-typography">

    <div class="allheaders">
      <div class="fixrow sep">
        <span>Column Headers</span>
        <span> Active Columns</span>
      </div>

      <ng-container *ngFor="let item of FieldColumnToogle;let i = index">
        <!-- <div class="sep" *ngIf="i==0">
          <span>{{item.fieldName}}</span>
          <span>
            <mat-slide-toggle checked disabled color="primary"></mat-slide-toggle>
          </span>
        </div> -->
        <div class="sep">
          <span>{{item.fieldName}}</span>
          <span>
            <mat-slide-toggle [checked]="item.isDisplay" color="primary" (change)="changedToggle(item,$event)">
            </mat-slide-toggle>
          </span>
        </div>
      </ng-container>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeCustomeColumn()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!SubmitColumnsButton" (click)="onSubmitColumns()">Save</button>
  </mat-dialog-actions>
</ng-template>



<ng-template #sendReminder>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Send Email Notification
    <button mat-icon-button (click)="closeSendReminder()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <mat-dialog-content class="mat-typography">

    <div class="allheaders">
      <div class="search">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Email</mat-label>
          <input matInput maxlength="200" placeholder="Add email" [(ngModel)]="repeatTaskEmail">
        </mat-form-field>
      </div>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeSendReminder()">Cancel</button>
    <button mat-flat-button color="primary"  
    (click)="onSendManualTaskReminder()">
    Send
  </button>
  </mat-dialog-actions>
</ng-template>



<ng-template #saveAsTemplateTaskDialog>
  <form [formGroup]="addTemplateForm">
    <h2 mat-dialog-title>
      <!-- {{taskTitleForSingleTask}} -->
      <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
      Save/Update Template
      <button mat-icon-button (click)="closeSaveAsTemplateForSingleTask()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <mat-radio-group color="primary" aria-label="Select an option">
        <mat-radio-button value="0" (change)="OnCategoryChangeForSingleTask(0)" [checked]="categoryTypeForSingleTask==0"
          style="margin-right: 15px;">My Templates</mat-radio-button>
        <mat-radio-button value="2" *ngIf="isOfficeAdmin || isOrganizationAdmin" (change)="OnCategoryChangeForSingleTask(2)" [checked]="categoryTypeForSingleTask==2"
          style="margin-right: 15px;">Save as Organization Template</mat-radio-button>
        <mat-radio-button value="1" *ngIf="isSuperAdmin" (change)="OnCategoryChangeForSingleTask(1)" [checked]="categoryTypeForSingleTask==1">
          Save Global Template Only</mat-radio-button>
      </mat-radio-group>

      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="getTabDetailsForSingleTask($event)">
        <mat-tab label="New">

          <div class="tabContainer">
            <div class="d-flex">

              <mat-form-field appearance="fill">
                <mat-label>Select Category</mat-label>
                <mat-select formControlName="folderID">
                  <mat-option *ngFor="let stat of filteredTaskCategoryList" [value]="stat.taskTemplateCategoryID">
                    {{ stat.taskTemplateCategoryName }}
                  </mat-option>
                </mat-select>

              </mat-form-field>

              <button class="addBtn" mat-icon-button color="primary" (click)="openDialogAddWithRef()">
                <mat-icon>add</mat-icon> </button>
            </div>
            <mat-form-field class="">
              <mat-label>Template Name</mat-label>
              <input matInput formControlName="taskTemplateName" maxlength="100" placeholder="Add Template Name" />
            </mat-form-field>
          </div>
        </mat-tab>

        <mat-tab label="Update Existing">
          <div class="tabContainer">

            <div class="searchSelectCat">
              <div class="selectCat">
                <mat-form-field appearance="fill">
                  <mat-label>Select Category</mat-label>
                  <mat-select (selectionChange)="getSelectTaskCategoryForSingleTask($event)">
                    <mat-option value="0">All</mat-option>
                    <mat-option *ngFor="let stat of filteredTaskCategoryList" [value]="stat.taskTemplateCategoryID">
                      {{ stat.taskTemplateCategoryName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>


              <div class="search">
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>Search</mat-label>
                  <input matInput maxlength="20" placeholder="Search Template"
                    (input)="searchTemplateForSingleTask($event.target.value)">
                </mat-form-field>
              </div>
            </div>


            <div class="tempalteList">
              <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
                <tr>
                  <th class="formName" >Template Name</th>
                  <!-- <th>Category Name</th> -->
                  <th class="actBtn">Action</th>
                </tr>
                <tr *ngFor="let template of TaskTemplatesListForSingleTask"
                  [ngClass]="{ 'active': template.taskId === taskTemplateIDForSingleTask}">

                  <td class="formName">
                    {{template.templateName}}
                  </td>

                  <!-- <td *ngIf="template.folderName==null">-</td>
                  <td *ngIf="template.folderName!=null">{{template.folderName}}</td> -->

                  <td class="actBtn">
                    <button mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip"
                      matTooltip="Select" (click)="SelectTemplateForAddTaskListForSingleTask(template)"><mat-icon>post_add</mat-icon>
                    </button>
                  </td>
                </tr>
              </table>
              <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Records Found</div>
            </div>
          </div>

        </mat-tab>
      </mat-tab-group>

    </mat-dialog-content>

    <mat-dialog-actions *ngIf="showNew" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSaveAsTemplate()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="addTemplateForm.invalid || !addTemplateForm.dirty" (click)="AddTaskTemplateForSingleTask(addTemplateForm.value)">
        Add
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

    <mat-dialog-actions *ngIf="showExisting" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSaveAsTemplateForSingleTask()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="!updateTaskTemplateTasksButton" (click)="AddSingleTaskTemplateForSingleTask(addTemplateForm.value)">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

  </form>
</ng-template>


<ng-template #template>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Template Gallery
    <button mat-icon-button (click)="closeTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <div class="searchSelectCat">
      <div class="selectCat">
        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select (selectionChange)="getSelectTaskCategory($event)">
            <mat-option *ngFor="let stat of taskCategoryList" [value]="stat.taskTemplateCategoryID">
              {{ stat.taskTemplateCategoryName }}
            </mat-option>
          </mat-select>
         
        </mat-form-field>
      </div>


      <div class="search">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input matInput maxlength="20" placeholder="Search Template" (input)="searchTemplate($event.target.value)">
        </mat-form-field>
      </div>
    </div>

    <div class="tempalteList">
      <table cellspacing="0" cellspadding="0">
        <tr>
          <th>Template Name</th>
          <th>Category Name</th>
          <th class="actBtn">Action</th>
        </tr>
        <tr>

          <td class="formName">
            Template 1
          </td>
          <td>Category 1</td>
          <td>

            <button mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip"
              matTooltip="Create Project"><mat-icon>post_add</mat-icon>
            </button>

          </td>
        </tr>
      </table>

    </div>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="" (click)="closeTemplate()">Close</button>
  </mat-dialog-actions>
</ng-template>



<ng-template #importTasktemplate>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Single Task Template Gallery
   
    <button mat-icon-button (click)="closeImportTaskTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
 

    <div class="template-holder">
      <div class="left">

        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select (selectionChange)="onTaskListTabChangeForTaskImport($event)" value="My Template">
            <mat-option value="My Template">My Template</mat-option>
            <mat-option value="Organization">Organization</mat-option> 
            <!-- <mat-option value="Global">Global</mat-option> -->
          </mat-select>
        </mat-form-field>

        <div class="list" #categoryList>
          <ul>
            <li (click)="getTaskListThroughCategoryForTaskImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }" >All</li>
            <ng-container  *ngFor="let stat of filteredTaskCategoryList; let i = index">
              <li (click)="getTaskListThroughCategoryForTaskImport(stat.taskTemplateCategoryID, i+1)" [ngClass]="{'active': currentIndex == i+1 }"  > {{ stat.taskTemplateCategoryName }}</li>
            </ng-container>           
          </ul>
        
        </div>

      </div>
     <div class="right"> 
       
      

       <div class="searrch">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input matInput maxlength="20" placeholder="Search Template"
            (input)="searchTemplateForSingleTask($event.target.value)">
        </mat-form-field>
       </div>
  
       <div class="list">

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
            <tr>
              <th> </th>
              <th>Template Name</th>             
              <th class="">&nbsp;</th>
            </tr>
            <tr *ngFor="let template of  TaskTemplatesListForSingleTask"
             [ngClass]="{ 'active': template.taskId === taskTemplateIDForSingleTask}">

             <td>
              <mat-checkbox color="primary" (change)="getCheckboxValues($event, template)">
              </mat-checkbox>
            </td> 

              <td class="formName">
                {{template.templateName}}
              </td>            

              <td>
                &nbsp;
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
        </div>

       </div>
  
     </div>
  </div>  

  <section class="importTo" *ngIf="selectedTemplate.length>0">
    <p>Would you like to import data for the newly created task-list? If so, please select the appropriate options below. If not, simply uncheck any boxes you do not wish to pull data from.</p>
    <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach</mat-checkbox> &nbsp;
    <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assignee</mat-checkbox>&nbsp;
    <!-- <mat-checkbox color="primary" [(ngModel)]="NotifyChecked" (change)="showOptions($event,'Notify')">Notify</mat-checkbox> -->
  </section>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeImportTaskTemplate()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="selectedTemplate.length>0"
      (click)="importTaskTemplates()">
      Import     
    </button>
  </mat-dialog-actions> 
 
</ng-template>

<app-loader></app-loader>